import React, { Component } from 'react'
import { Button, ButtonType, DialogHeader } from '@checkmarx/cx-ui';
import Dialog from 'material-ui/Dialog';
import { Scrollbars } from 'react-custom-scrollbars';
import TeamsTreeView from '../../teams/teamsTreeView';

export default class SelectTeamDialog extends Component {
    
    render() {
        
        const customContentStyle = {
            width: '470px',
            backgroundColor: '#D82D49',
            padding: 0
        };

        const title = <DialogHeader 
                        title={this.props.translations.headerTitle}
                        closeClick={this.props.closeDialog}
                        displayCloseButton
                    />;

        const actions = [
            <span className='portal-blank-button' onClick={this.props.closeDialog}>
                {this.props.translations.cancelButton}
            </span>,
            <Button 
                dataCy='select-team-button'
                onClick={this.props.onSave}
                disabled={this.props.selectedKeys === undefined || this.props.selectedKeys.length === 0}
                text={this.props.translations.selectTeamButton}
            >
            </Button>
        ];

        return (
            <Dialog 
                title={title}
                className='portal-confirm-dialog add-team-member-dialog'
                titleClassName='portal-confirm-dialog-header alert-confirm'
                actionsContainerClassName='portal-confirm-dialog-actions top-border'
                teams={this.props.teams}
                actions={actions}
                bodyStyle={{
                    height: '490px',
                    padding: 0
                }}
                modal={true}
                contentStyle={customContentStyle}
                open={this.props.openDialog}
            >
                <div style={{
                    height: 370,
                    padding: '25px',
                    paddingTop: '10px'
                }}>
                <Scrollbars className='select-teams-dialog-scrolls'>
                    <TeamsTreeView
                        selectable={true}
                        onSelect={this.props.onTeamSelect}
                        selectedKeys={this.props.selectedKeys}
                    />
                </Scrollbars>
                </div>
            </Dialog>
        );
  }
}



// WEBPACK FOOTER //
// ./src/components/portal/controls/selectTeamDialog.jsx